import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CallTranscript } from '~/types/CallTranscript'
import { convertCallDuration } from '~/utils/formatter'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { SectionHeader } from './SectionHeader'

interface HoldAndPauseTimeSectionProps {
  transcript: CallTranscript
}

export const HoldAndPauseTimeSection = ({
  transcript,
}: HoldAndPauseTimeSectionProps) => {
  const { t } = useTranslation()
  const holdTimeSeconds =
    (transcript.ConversationCharacteristics.NonTalkTime.TotalTimeMillis /
      1000) |
    0

  const callDurationSeconds =
    (transcript.ConversationCharacteristics.TotalConversationDurationMillis /
      1000) |
    0

  const percentageOfCall =
    (callDurationSeconds ? holdTimeSeconds / callDurationSeconds : 0) * 100

  const color = percentageOfCall >= 50 ? 'red.solid' : 'fg.default'

  return (
    <Flex
      flexDirection="column"
      width="100%"
      gap="1.5rem"
      justifyItems="stretch"
      height="7.125rem"
    >
      <SectionHeader
        title={t('callDetails.sections.holdAndPauseTime.title')}
        tooltipText={t('callDetails.sections.holdAndPauseTime.tooltip')}
      />
      <Flex flexDirection="column" justifyContent="center" flex="1 0 0">
        <Text {...textStyles[textStyleKeys.H1]} color={color} marginTop="-1rem">
          {convertCallDuration(holdTimeSeconds)}
        </Text>
        <Text {...textStyles[textStyleKeys.Body3]}>
          {t('callDetails.sections.holdAndPauseTime.percentageOfCall', {
            percentage: percentageOfCall.toFixed(0),
          })}
        </Text>
      </Flex>
    </Flex>
  )
}
